import { render, staticRenderFns } from "./BetaBadge.vue?vue&type=template&id=05acc083&"
import script from "./BetaBadge.vue?vue&type=script&lang=js&"
export * from "./BetaBadge.vue?vue&type=script&lang=js&"
import style0 from "./BetaBadge.vue?vue&type=style&index=0&id=05acc083&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports